import React, {Component} from 'react';
import styled from 'styled-components'
import {connect} from 'react-redux'

import {schoolActions, schoolSelectors} from "../../store/school";
import {authActions, authSelectors} from "../../store/auth";
import {searchActions} from "../../store/search";
import {Backdrop, Block, Divider, Overlay, Portal, Tabs} from "reakit";
import {Box, Flex, Heading, Image, Text} from 'rebass';
import {FloatingButton} from "../Base/Buttons";
import {withFirebase} from "../Firebase";
import {MapMarkerAlt} from "styled-icons/fa-solid";
import {TabHeader} from "../Base";
import check from "../../resources/img/icons/Checkbox@1x.png";

const PanelWrapper = styled(Box)`
//min-width: 250px;
//	height: calc(100vh - 131px);
//	margin-bottom: 10px;
	height: calc(45vh - 150px);
   overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	height: 70vh;

  }
`;


// This WavePopup component does not include the Wave Button

const MapMarker = styled(MapMarkerAlt)`
  width: 20px;
  height: 20px;
  color: white;
`;
const FilterOverlay = styled(Overlay)`

		width: 50%;
 		height: 50%;
 @media(max-width: 700px){
 		width: 100%;
		height: 100%;
 }
`;

const textProps = {
	ml: 3
};


class WavePopup extends Component {

	state = {
		onLeave: false,
		leaveType: null,
		current: null,
		locations: [],
		history: [],
		locationSearch: ''
	};

	componentDidMount() {

		const {school} = this.props;
		const locations = {
			list: school.locations.list,
			map: school.locations.map
		}
		const locationsToState = {
			locations: locations
		}
		this.setState({
			locationsToState
		});
		
	}

	handleSelect = (location, toggle) => {
		//.log('selected', location);
		// const {handleSelect} = this.props;
		this.setState({current: location.id})
		//console.log('selected', location);
		const {isFaculty, student, profile} = this.props;
		try {
			if (isFaculty) {
				// todo
				let studentRef = this.props.firebase.student(student.id);
				let waveRef = studentRef.collection('wave_history');
				let newWave = waveRef.doc();
				newWave.set({
					creator_uid: profile.id,
					location_is_geowave: false,
					location_uid: location.id,
					post_time: Math.floor(Date.now() / 1000)
				});
				studentRef.update({
					current_location: location.id
				});
			} else {
				let studentRef = this.props.firebase.student(student.id);
				let waveRef = studentRef.collection('wave_history');
				let newWave = waveRef.doc();
				newWave.set({
					creator_uid: profile.id,
					location_is_geowave: false,
					location_uid: location.id,
					post_time: Math.floor(Date.now() / 1000)
				});
				studentRef.update({
					current_location: location.id
				});

				this.setState({current: location.id});
			}
		}catch (error) {
			//console.log(error)
		}

		toggle()

	};

	handleSubmit = () => {
		const {current} = this.state;
		const {handleConfirm, toggle} = this.props;
		handleConfirm(current);
		toggle()
	};

	handleGeoWave = () => {
		// todo Geo Wave
		const { toggle} = this.props;
		toggle()

	};


	componentWillUnmount() {
		// this.listener()
	}

	render() {
		const { current, locationSearch} = this.state;
		const { isFaculty, school, visible, toggle} = this.props;
		let location = '';
		// const locations = school.locations.list
		if (!isFaculty && current !== null) {

			const locationData = school.locations.map[current];
			// let campus = '';
			// if (locationData.is_oncampus === true) {
			// 	campus = 'On - '
			// } else {
			// 	campus = 'Off - '
			// }
			location = locationData.is_oncampus ? 'ON - ' : 'OFF - ' + locationData.name

		}
		return (
			<Overlay.Container>
				{overlay => (
					<Block>

						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} visible={visible}>
							<FloatingButton onClick={current === null ? this.handleGeoWave : this.handleSubmit}>{current === null ?
								<MapMarker/> : <Image src={check}/>}

							</FloatingButton>
							<Box>
								<Text onClick={toggle}>X</Text>
								<Heading>At {location}</Heading>
								<Block>
									<Tabs.Container>
										{tabs => (
											<Block>
												<Tabs>
													<Tabs.Tab tab="on" {...tabs}><TabHeader title={'ON'}/></Tabs.Tab>
													<Tabs.Tab tab="off" {...tabs}><TabHeader title={'OFF'}/></Tabs.Tab>


												</Tabs>
												<Tabs.Panel tab="on" {...tabs}>
													<PanelWrapper>
														<Divider/>
														{locationSearch !== '' && locationSearch.locations.list.filter(item => item.is_oncampus).map(location =>
															location.activated ?
															<Box key={location.id} onClick={() => this.handleSelect(location, overlay.hide)}>
																<Flex>
																	<Box>
																		<Text {...textProps}>{location.name}</Text>
																	</Box>
																	<Box ml={'auto'}/>
																	<Box pr={2}>
																		{current === location.id && <Image src={check}/>}
																	</Box>
																</Flex>
																<Box width={1}>
																	<Divider/>
																</Box>
															</Box>
															: ""
														)}


													</PanelWrapper>
												</Tabs.Panel>
												<Tabs.Panel tab="off" {...tabs}>
													<PanelWrapper>
													<Divider/>
													{locationSearch !== '' && locationSearch.locations.list.filter(item => !item.is_oncampus).map(location =>
														location.activated ?
														<Box key={location.id} onClick={() => this.handleSelect(location, overlay.hide)}>
															<Flex>
																<Box>
																	<Text {...textProps}>{location.name}</Text>
																</Box>
																<Box ml={'auto'}/>
																<Box pr={2}>
																	{current === location.id && <Image src={check}/>}
																</Box>
															</Flex>
															<Box width={1}>
																<Divider/>
															</Box>
														</Box>
														: ""
													)}
													</PanelWrapper>
												</Tabs.Panel>

											</Block>
										)}
									</Tabs.Container>
								</Block>
							</Box>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

const mapStateToProps = (state) => ({
	school: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loading: authSelectors.isLoading(state.auth),
	// filters: searchSelectors.refreshFilters(state.search)
});

const mapDispatchToProps = (dispatch) => ({
	updateSchoolInfo: (data) => {
		dispatch(schoolActions.updateSchoolInfo(data))
	},
	updateProfileInfo: (data) => {
		dispatch(authActions.updateProfileInfo(data))
	},
	handleUpdate: (filters) => {
		dispatch(searchActions.updateFilter(filters))
	}
});


export default withFirebase(connect(
	mapStateToProps,
	mapDispatchToProps
)(WavePopup))

